export const colorsBackground = [
  '#C39C4D',
  '#323232',
  '#8D5C24',
  '#C78620',
  '#A5A5A5',
  '#FBD348',
]

export const colorsFonts = [
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
]
